
import { Grid, styled } from "@mui/material";
import {
    useMediaQuery,
    useTheme,
} from "@mui/material";
import BreadCrumbComponent from "components/BreadCrumb/BreadCrumbComponent";
import Appbar from "./Appbar";
import { ScrollToBottom } from "components/Common/Button/ScrollToBottom";
import Fab from "@mui/material/Fab";
import {
    HiOutlineArrowNarrowDown,
    HiOutlineArrowNarrowUp,
} from "react-icons/hi";
import { ScrollToTop } from "components/Common/Button/ScrollToTop";
import LayoutFooter from "layout/LayoutFront/LayoutFooter";
import BgFront from "../../assets/Image/Backg.png";
import UserAvatar from "../../assets/Image/user-avatar.png";
import { useEffect, useState } from "react";
import { AlertTitle, AlertTitleTh, AxiosGet, ResultAPI } from "service/CommonFunction/TS_function";
import * as signalR from "@microsoft/signalr";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { useLocation, useNavigate } from "react-router-dom";
import { currentLanguage } from "service/CommonFunction/AxiosConfig";
import { SwAlert } from "components/Common/Alert/AlertForm";


const ContainerBG = styled("div")(
    {
        // backgroundImage: `url(${bgMain1})`,
        // background: 'radial-gradient(ellipse at center, rgba(79, 79, 79, 1) 0%, rgba(34, 34, 34, 1) 100%)',
        backgroundImage: `url(${BgFront})`,
        // backgroundImage: `linear-gradient(0deg, rgba(7,35,63,0.8687850140056023) 0%, rgba(255,255,255,0.28335084033613445) 100%), url(${TopFooter})`,
        // background: `radial-gradient(410px 50px at 50% 0,transparent, 80%, #000 80.5%) center,radial-gradient(410px 50px at 50% 50px,#000, 80%, transparent 80.5%)center,linear-gradient(#000,#000) content-box, url(${bgMain1})`,
        backgroundPositionX: "center",
        backgroundPosittionY: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        boxShadow: '-2px -3px 14px -6px #888888',
        paddingBottom: '2em',
        backgroundAttachment: "fixed"
    }
);

type Props = {
    children?: React.ReactNode;
    propLayout?: any,
    IsRefresh?: any
    setIsRefresh?: any
};

const LayoutFront: React.FC<Props> = ({ children, propLayout, IsRefresh, setIsRefresh }) => {

    const location = useLocation();
    const Layout900 = useMediaQuery('(min-width:900px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');
    const Layout360 = useMediaQuery('(min-width:360px)');
    const [dataMenu, setDataMenu] = useState([] as any);
    const [connection, setConnection] = useState<null | HubConnection>(null);
    const [lstProduct, setlstProduct] = useState([] as any)
    const [objService, setobjService] = useState(null)
    const navigate = useNavigate();


    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sPathImage": null,
        "sCompany": null,
        "sBA": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })


    useEffect(() => {
        onGetMenu();

        const baseUrl = process.env.REACT_APP_API_URL
        const locationUrl = baseUrl + location.pathname
        const currentUrl = baseUrl + '/Front/Profile'
        
        if (locationUrl != baseUrl + '/Front/Profile') {
            GetUserData();
        }
    }, [location.pathname])

    useEffect(() => {
        GetUserData();
    }, [IsRefresh, DataUser?.nUserID])

    useEffect(() => {
        GetProductHeader()
        GetServiceHeader()
    }, [])

    useEffect(() => {
        // onJoinAllNotify();
    }, []);

    const onJoinAllNotify = () => {
        const connect = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_API_URL + "SignalRChat")
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();
        setConnection(connect);
    }

    const GetProductHeader = async () => {

        return null

    }

    const GetServiceHeader = async () => {
        await AxiosGet(`Service/GetService`, { "IsHeadService": true, "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                let result = res.result.data;
                if (result != null && result.length > 0) {
                    setobjService(result[0])
                    return result[0]
                }
            })
        });
        return null

    }

    const onGetMenu = async () => {
        setDataMenu([])
        AxiosGet("Systems/GetMenuFront", {}, async (res) => {
            setDataMenu(res.lstMenu);
            let lstPrd = [] as any;


            await AxiosGet(`Product/GetProduct`, { "IsHeadProduct": true, "sLanguage": currentLanguage() }, (res) => {
                ResultAPI(res, null, () => {
                    setlstProduct(res.result.data || [])
                    lstPrd = res.result.data || []
                })
            });

            let oService = null

            await AxiosGet(`Service/GetService`, { "IsHeadService": true, "sLanguage": currentLanguage() }, (res) => {
                ResultAPI(res, null, () => {
                    let result = res.result.data;
                    if (result != null && result.length > 0) {
                        setobjService(result[0])
                        oService = result[0]
                    }
                })
            });

            if (res.lstMenu != null && res.lstMenu.length > 0) {
                let arrSub = [] as any

                let objMenuPrd = {} as any;

                (res.lstMenu).forEach((element, idx) => {
                    if (element.nMenuID == 2) {
                        let lstMenu = [] as any;
                        if (lstPrd != null && lstPrd.length > 0) {
                            lstPrd.forEach(element => {
                                lstMenu.push({
                                    sID: element.sProductID,
                                    sName: element.sProductName,
                                    sLink: "/Front/Product?sID=" + element?.sProductID
                                })
                            });
                        }
                        objMenuPrd = {
                            sType: currentLanguage() == "en" ? "Products" : "ผลิตภัณฑ์",
                            lstmenu: lstMenu
                        }
                        arrSub.push(objMenuPrd);

                        let lstMenuService = [] as any;
                        let objMenuService = {} as any;
                        if (oService != null) {
                            lstMenuService.push({
                                sID: oService?.sServiceID,
                                sName: oService?.sServiceName,
                                sLink: "/Front/Service?sID=" + oService?.sServiceID
                            })
                        }
                       

                        lstMenuService.push({
                            sID: "xX",
                            sName: currentLanguage() == "en" ? "Services" : "การอบรม",
                            sLink: "/Front/Training"
                        })

                        objMenuService = {
                            sType: currentLanguage() == "en" ? "Training" : "บริการ",
                            lstmenu: lstMenuService
                        }
                        arrSub.push(objMenuService);


                        element.lstSubMenu = arrSub

                    }
                });
            }


        })
    };

    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                if (res.result.IsReset == true) {
                    SwAlert.Warning(AlertTitle.Warning, "<p>กรุณาเปลี่ยนรหัสผ่านของท่าน ด้วยเหตุผลด้านความปลอดภัย<br>หลังจากระบบได้รับการแจ้งรีเซ็ตรหัสผ่าน</p>", () => {
                        navigate("/Front/Profile");
                    });
                }
                if (res.result.sPathImage) {
                    const img = new Image()
                    img.src = res.result.sPathImage
                    var result = new Promise((resolve) => {
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                    });
                    result.then(reustItem => {
                        var img = reustItem ? res.result.sPathImage : UserAvatar
                        res.result.sPathImage = img;
                    })
                } else {
                    res.result.sPathImage = UserAvatar;
                }

                setDataUser({
                    "nUserID": res.result.nUserID || 0,
                    "sUserCode": res.result.sUserCode || null,
                    "sPathImage": res.result.sPathImage || null,
                    "sCompany": res.result.sCompany || null,
                    "sBA": res.result.sBA || null,
                    "sFullname": res.result.sFullname || null,
                    "sAPIRoleName": res.result.sAPIRoleName || null,
                    "sUserType": res.result.sUserType || null,
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": res.result.lstUserBA || [],
                });
            })
        })
    };

    return (
        <div style={{ width: '100%', height: '100%', minHeight: '100vh', position: 'relative' }}>
            <Grid container justifyContent={'center'} alignItems={'start'}>
                <Grid item >
                    <Appbar
                        dataMenu={dataMenu}
                        DataUser={DataUser}
                        setDataUser={setDataUser}
                        connection={connection}
                        lstProduct={lstProduct}
                        objService={objService}
                    />
                </Grid>
                <Grid item xs={12} style={{ minHeight: '37vh', marginTop: !Layout1000 ? "64px" : "0px" }}>
                    <ContainerBG>
                        {children}
                    </ContainerBG>
                </Grid>
            </Grid>
            <LayoutFooter dataMenu={dataMenu} />
            {propLayout.showPageDown ?
                <>
                    <ScrollToBottom>
                        <Fab
                            color="primary"
                            size="large"
                            sx={{
                                flexDirection: "column",
                                borderRadius: "16px",
                                width: "35px",
                                height: "70px",
                                textAlign: "center",
                                lineHeight: "1",
                                fontSize: "10px",
                            }}
                        >
                            <HiOutlineArrowNarrowDown size="25" />
                            <span style={{ marginTop: '8px' }}>
                                DOWN
                            </span>
                        </Fab>
                    </ScrollToBottom>
                </>
                : null
            }
            {propLayout.showPageUp ?
                <>
                    <ScrollToTop>
                        <Fab
                            color="error"
                            size="large"
                            sx={{
                                flexDirection: "column",
                                borderRadius: "16px",
                                width: "35px",
                                height: "70px",
                                textAlign: "center",
                                lineHeight: "1",
                                fontSize: "13px",
                            }}
                        >
                            <HiOutlineArrowNarrowUp size="25" />
                            <span style={{ marginTop: '8px' }}>
                                Top
                            </span>
                        </Fab>
                    </ScrollToTop>
                </>
                : null
            }
        </div>
    );
};
export default LayoutFront;

